import { combineReducers } from 'redux';

import Global from './Global';

export default combineReducers({
    Global,
});
